/**
 * This is the key used to store the branding config in the local storage.
 * It is used to avoid unnecessary re-fetching of the config which saves inital loading time.
 */
export const BRANDING_STORAGE_KEY = 'dashboard-branding';
